<div class="layout__inner-card mb-5">
  <em-profile-decision-popup-header></em-profile-decision-popup-header>

  <div [innerHTML]="preInputText[languageCode] | emMarkdown"></div>
  @if (form) {
    <textarea [formControl]="form" class="w-full my-3" rows="7" [maxlength]="5000" pInputTextarea></textarea>
  }
  <div [innerHTML]="postInputText[languageCode] | emMarkdown"></div>
</div>

<p-button
  (onClick)="submit()"
  [disabled]="form?.invalid"
  class="justify-content-center flex"
  icon="pi pi-check"
  i18n-label
  label="Approuver"></p-button>
